import React from "react";

const IconLoader = () => {
  return (
    <div
      className="flex justify-center items-center h-screen"
      style={{ maxHeight: "calc(100vh - 170px)" }}
    >
      <div className="block w-[50px]">
        <img
          alt="Logo"
          src={require("../assets/img/ShiproneLogo.png")}
          className="animate-bounce"
        />
      </div>
    </div>
  );
};

export default IconLoader;
